// User ids are lowercase on the backend, but a /me cached from before that
// rule (or an older row) may still carry capitals — compare ids case-folded.
export function sameUserId(a: string | null | undefined, b: string | null | undefined): boolean {
  if (typeof a !== "string" || typeof b !== "string") return false
  return a.toLowerCase() === b.toLowerCase()
}
